export default __webpack_public_path__ + "img/Poppins-Light_081fa18.woff";